import { Center } from "@chakra-ui/react";
import CloseIcon from "@components/CloseIcon";
import ModalDrawer from "@components/ModalDrawer";
import SuccessErrorModalBodyTemplate from "@components/SuccessErrorModalBodyTemplate";
import { TransactionType } from "@constants/types";

interface StakeConfirmationProps {
  isOpen: boolean;
  onClose: () => void;
  onPrimaryClick: () => void;
}
const StakeConfirmation = ({
  isOpen,
  onPrimaryClick,
  onClose,
}: StakeConfirmationProps) => {
  return (
    <ModalDrawer isOpen={isOpen} closeAlert={onClose}>
      <Center
        padding={{ base: "0 1rem 2.5rem", md: "2.5rem 3rem" }}
        fontWeight="600"
        flexDirection="column"
        width="100%"
      >
        <CloseIcon onClose={onClose} />
        <SuccessErrorModalBodyTemplate
          transactionType={TransactionType.INFO}
          modalTitle="EL Points Optimisation"
          modalSubTitle="EigenLayer has a low capacity of stETH available. You hereby authorize KelpDAO to convert stETH into ETHx or sfrxETH to restake based on EigenLayer caps for earning EL points"
          modalExtraText="This is an automatic conversion, and you will not incur any losses."
          primaryBtnTxt="Deposit stETH"
          onSubmitPrimary={() => onPrimaryClick()}
          // secondaryBtnTxt="Restake ETHx"
          // onSubmitSecondary={() => onSecondaryClick()}
        />
      </Center>
    </ModalDrawer>
  );
};

export default StakeConfirmation;
